import { render, staticRenderFns } from "./CustomerRegister.vue?vue&type=template&id=6f1667a0"
import script from "./CustomerRegister.vue?vue&type=script&lang=js"
export * from "./CustomerRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports